/*
  Makes the "Needed by" date picker usable inside the bulk enquiry dialog.

  The form app uses flatpickr, which appends its calendar to <body>. The dialog
  is opened with showModal(), which puts it in the browser's top layer - and the
  top layer paints above everything in <body> no matter how high a z-index the
  calendar sets. So the calendar did open, invisibly, behind the dialog, and was
  inert to clicks.

  The fix moves the calendar into the dialog on open and positions it against
  the input, clamped so it cannot run off the dialog's right edge. The hook is
  pushed onto flatpickr's existing onOpen array rather than replacing it, so the
  app's own handlers still run.
*/
(function () {
  var DIALOG_ID = 'PvBulkModal';

  function patch(dialog) {
    var inputs = dialog.querySelectorAll('input.flatpickr-input');
    var patched = 0;

    Array.prototype.forEach.call(inputs, function (input) {
      var fp = input._flatpickr;
      if (!fp || input.dataset.pvFpPatched) return;
      input.dataset.pvFpPatched = '1';
      patched++;

      function place() {
        var cal = fp.calendarContainer;
        if (!cal) return;
        if (cal.parentElement !== dialog) dialog.appendChild(cal);

        var ir = input.getBoundingClientRect();
        var dr = dialog.getBoundingClientRect();
        var w = cal.offsetWidth || 308;

        cal.style.position = 'fixed';
        cal.style.top = ir.bottom + 4 + 'px';
        cal.style.left = Math.max(dr.left + 12, Math.min(ir.left, dr.right - w - 12)) + 'px';
        cal.style.zIndex = '99999';
      }

      if (Array.isArray(fp.config.onOpen)) fp.config.onOpen.push(place);
      else fp.set('onOpen', place);

      window.addEventListener('resize', function () {
        if (fp.isOpen) place();
      });
    });

    return patched;
  }

  function onOpened(dialog) {
    // The app builds its form asynchronously, so the flatpickr instance may not
    // exist the moment the dialog opens. Try for a few seconds, then give up.
    var tries = 0;
    (function attempt() {
      if (patch(dialog) > 0 || tries++ > 20) return;
      setTimeout(attempt, 250);
    })();
  }

  function watch() {
    var dialog = document.getElementById(DIALOG_ID);
    if (!dialog) return false;

    if (dialog.open) onOpened(dialog);

    new MutationObserver(function () {
      if (dialog.open) onOpened(dialog);
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });

    return true;
  }

  function start() {
    if (watch()) return;
    // The dialog is rendered from theme.liquid near the end of <body>.
    var obs = new MutationObserver(function () {
      if (watch()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
